//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.BundledProduct
import com.tixforgigs.apax.models.ItemType
import com.tixforgigs.apax.models.PriceInfo
import com.tixforgigs.apax.models.ProductDisplayState

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The product model
* 
* @param availableItemTypes The available item types for this product
* @param contingentId The contingent id
* @param isBundle Defines if this product is bundled
* @param isPersonalized Defines if the product is personalized
* @param isSoldOut Defines if this product is sold out
* @param maxOrderCount The max amount of products a user can order
* @param productId The product id
* @param productPriceInfo 
* @param productTitle The title of the product
* @param sortOrder Defines the sort order of the product
* @param availableFrom First available from (offset)
* @param availableFromUTC First available from (utc date time)
* @param bundledProducts The bundled products
* @param comingSoon soon available
* @param description The description of the product
* @param floorPlanCategoryKey The category in the floor plan (if applicable)
* @param productDisplayState 
* @param supportsBestAvailable support of the seats.io best available option
* @param ticketPreview a link to the ticket artwork
*/
@Serializable

data class Product (


      /* The available item types for this product */
    @SerialName(value = "availableItemTypes") @Required val availableItemTypes: kotlin.collections.List<ItemType>,


      /* The contingent id */
    @SerialName(value = "contingentId") @Required val contingentId: kotlin.Int,


      /* Defines if this product is bundled */
    @SerialName(value = "isBundle") @Required val isBundle: kotlin.Boolean,


      /* Defines if the product is personalized */
    @SerialName(value = "isPersonalized") @Required val isPersonalized: kotlin.Boolean,


      /* Defines if this product is sold out */
    @SerialName(value = "isSoldOut") @Required val isSoldOut: kotlin.Boolean,


      /* The max amount of products a user can order */
    @SerialName(value = "maxOrderCount") @Required val maxOrderCount: kotlin.Int,


      /* The product id */
    @SerialName(value = "productId") @Required val productId: kotlin.Int,


      @SerialName(value = "productPriceInfo") @Required val productPriceInfo: PriceInfo,


      /* The title of the product */
    @SerialName(value = "productTitle") @Required val productTitle: kotlin.String,


      /* Defines the sort order of the product */
    @SerialName(value = "sortOrder") @Required val sortOrder: kotlin.Int,


      /* First available from (offset) */
    @SerialName(value = "availableFrom") val availableFrom: kotlin.Int? = null,


      /* First available from (utc date time) */
    @SerialName(value = "availableFromUTC") val availableFromUTC: kotlin.time.Instant? = null,


      /* The bundled products */
    @SerialName(value = "bundledProducts") val bundledProducts: kotlin.collections.List<BundledProduct>? = null,


      /* soon available */
    @SerialName(value = "comingSoon") val comingSoon: kotlin.Boolean? = null,


      /* The description of the product */
    @SerialName(value = "description") val description: kotlin.String? = null,


      /* The category in the floor plan (if applicable) */
    @SerialName(value = "floorPlanCategoryKey") val floorPlanCategoryKey: kotlin.String? = null,


      @SerialName(value = "productDisplayState") val productDisplayState: ProductDisplayState? = null,


      /* support of the seats.io best available option */
    @SerialName(value = "supportsBestAvailable") val supportsBestAvailable: kotlin.Boolean? = null,


      /* a link to the ticket artwork */
    @SerialName(value = "ticketPreview") val ticketPreview: kotlin.String? = null


) {




  }

